// Error action type
export const GET_ERRORS = "GET_ERRORS";

// Common --> Set message action type
export const SET_MESSAGE = "SET_MESSAGE";
export const SET_Info = "SET_Info";

// user profile --> personal info
export const PERSONAL_INFO_FETCH = "PERSONAL_INFO_FETCH";

export const PERSONAL_INFO_GET = "PERSONAL_INFO_GET";

// Login action types
export const AUTHENTICATE_USER = "AUTHENTICATE_USER";

export const LOGOUT_USER = "LOGOUT_USER";

// user management
export const USER_GET = "USER_GET";

export const USER_PERSONAL_GET = "USER_PERSONAL_GET";

export const USER_PERSONAL_INTEREST_GET = "USER_PERSONAL_INTEREST_GET";

export const USER_PERSONAL_TECHNOLOGY_GET = "USER_PERSONAL_TECHNOLOGY_GET";

export const USER_FETCH = "USER_FETCH";

export const COMMUNITY_USER_FETCH = "COMMUNITY_USER_FETCH";

export const COMMUNITY_USER_FILTER = "COMMUNITY_USER_FILTER";

export const ALL_PROFILE_PIC_DOWNLOAD = "ALL_PROFILE_PIC_DOWNLOAD";

export const ALL_USER_PROFILE_PIC_DOWNLOAD = "ALL_USER_PROFILE_PIC_DOWNLOAD";

// user profile --> company info
export const COMPANY_INFO_GET = "COMPANY_INFO_GET";

// user profile -->Qualification
export const QUALIFICATION_GET = "QUALIFICATION_GET";

// user profile --> User Profile info
export const USER_PROFILE_INFO_GET = "USER_PROFILE_INFO_GET";

// Communities ---> Community
export const COMMUNITY_GET = "COMMUNITY_GET";

export const COMMUNITY_NO_DATA = "COMMUNITY_NO_DATA";

// Opportunities ---> Opportunity
export const OPPORTUNITY_GET = "OPPORTUNITY_GET";

export const OPPORTUNITY_FETCH = "OPPORTUNITY_FETCH";

// Opportunities ---> apply opportunity
export const APPLY_OPPORTUNITY_FETCH = "APPLY_OPPORTUNITY_FETCH";

export const OPPORTUNITY_APPLIED = "OPPORTUNITY_APPLIED";

// Opportunities ---> Admin Opportunity
export const ADMIN_OPPORTUNITY_GET = "ADMIN_OPPORTUNITY_GET";

// Opportunities ----> Admin Opportunity Remarks
export const ADMIN_OPPORTUNITY_REMARKS_FETCH =
  "ADMIN_OPPORTUNITY_REMARKS_FETCH";

// Projects ---> Admin Project
export const ADMIN_PROJECT_GET = "ADMIN_PROJECT_GET";

// Tribes ---> Tribe
export const TRIBE_GET = "TRIBE_GET";

// Tribes ---> Post
export const POST_GET = "POST_GET";

export const POST_FETCH = "POST_FETCH";

export const COMMENT_FETCH = "COMMENT_FETCH";

export const COMMENT_GET = "COMMENT_GET";

// Events
export const EVENT_GET = "EVENT_GET";

export const EVENT_FETCH = "EVENT_FETCH";

// Blogs
export const BLOG_GET = "BLOG_GET";

export const BLOG_FETCH = "BLOG_FETCH";

// Faqs
export const FAQ_GET = "FAQ_GET";

export const FAQ_FETCH = "FAQ_FETCH";

// Surveys
export const SURVEY_GET = "SURVEY_GET";

export const SURVEY_FETCH = "SURVEY_FETCH";

export const SURVEY_ANSWER_GET = "SURVEY_ANSWER_GET";

// Survey -> Survey Category
export const SURVEY_CATEGORY_GET = "SURVEY_CATEGORY_GET";

// Survey -> Survey Prepare Questions
export const SURVEY_QUESTION_GET = "SURVEY_QUESTION_GET";

// Survey -> Survey Publish
export const PUBLISH_SURVEY_GET = "PUBLISH_SURVEY_GET";

export const CURRENT_PUBLISH_SURVEY_GET = "CURRENT_PUBLISH_SURVEY_GET";

// Survey -> Survey Results
export const SURVEY_RESULTS_GET = "SURVEY_RESULTS_GET";

export const SURVEY_USERS_FETCH = "SURVEY_USERS_FETCH";

export const USER_ANSWERED = "USER_ANSWERED";

// User --> Surveys
export const USER_SURVEY_GET = "USER_SURVEY_GET";

export const ALL_USER_SURVEY_GET = "ALL_USER_SURVEY_GET";

export const USER_SURVEY_ANSWER_GET = "USER_SURVEY_ANSWER_GET";

export const ANSWER_USER_SURVEY_FETCH = "ANSWER_USER_SURVEY_FETCH";

export const USER_RESPONSE_FETCH = "USER_RESPONSE_FETCH";

// Platform --> user setup ---> Skill set
export const SKILL_SET_GET = "SKILL_SET_GET";

// Platform --> user setup ---> Industry Domain
export const INDUSTRY_DOMAIN_GET = "INDUSTRY_DOMAIN_GET";

// Platform --> user setup ---> Faq Selection
export const FAQ_SECTION_GET = "FAQ_SECTION_GET";

// Platform --> system configuration --> user group
export const USER_GROUP_GET = "USER_GROUP_GET";

// Platform --> system configuration --> access group
export const ACCESS_GROUP_GET = "ACCESS_GROUP_GET";

export const ACCESS_GROUP_FETCH = "ACCESS_GROUP_FETCH";

// Platform --> system configuration --> Role management
export const ROLE_GET = "ROLE_GET";

export const ROLE_FETCH = "ROLE_FETCH";

export const ROLE_SEARCH = "ROLE_SEARCH";

// Platform --> system configuration --> Access Permission
export const ACCESS_PERMISSION_GET = "ACCESS_PERMISSION_GET";

export const SUB_ACCESS_PERMISSION_GET = "SUB_ACCESS_PERMISSION_GET";

// Platform --> system configuration --> Menu management
export const MENU_GET = "MENU_GET";

export const SUB_MENU_GET = "SUB_MENU_GET";

export const MENU_FETCH = "MENU_FETCH";

// Platform --> business setup

//Platform - Business Geographies
export const BUSINESS_GEOGRAPHIES_GET = "BUSINESS_GEOGRAPHIES_GET";

//Platform - Business Geographies
export const BUSINESS_GEOGRAPHIES_ADD = "BUSINESS_GEOGRAPHIES_ADD";

export const BUSINESS_GEOGRAPHIES1_GET = "BUSINESS_GEOGRAPHIES1_GET";

export const BUSINESS_GEOGRAPHIES_UPDATE = "BUSINESS_GEOGRAPHIES_UPDATE";

export const BUSINESS_GEOGRAPHIES_DELETE = "BUSINESS_GEOGRAPHIES_DELETE";

//Platform - Business Location
export const BUSINESS_LOCATION_GET = "BUSINESS_LOCATION_GET";

// Platform - Business setup - Survey Types
export const SURVEY_TYPE_GET = "SURVEY_TYPE_GET";


//publish-jobs
export const VIEW_PUBLISH_TYPE = "VIEW_PUBLISH_TYPE"

export const GET_REFERAL_CANDI_TYPE = "GET_REFERAL_CANDI_TYPE"

export const GET_APPLY_TYPE = "GET_APPLY_TYPE"
export const SEARCH_APPLY_JOBS = "SEARCH_APPLY_JOBS"

//matched-jobs

export const GET_MATCHED_JOBS_TYPE = "GET_MATCHED_JOBS"